import { CLINIC_PAYMENT_METHOD_ENUM, CLINIC_STATUS_ENUM } from '../appContants';

export function getInvoicePaymentStatusTagColor(paymentId) {
  return {
    text: paymentId ? 'PAID' : 'UN-PAID',
    color: paymentId ? '#20c997' : '#dc3545',
    isPaid: !!paymentId
  };
}
export function getInvoicePaymentStatusTagColorWithPaymentPlatform(payment) {
  return {
    text: payment.paymentId ? 'PAID' : 'UN-PAID',
    color: payment.paymentId ? '#20c997' : '#dc3545',
    paymentPlatform: payment.paymentPlatform,
  };
}
export function getInvoiceEmailSentStatusTagColor(emailedStatus) {
  return {
    text: emailedStatus ? 'SENT' : 'PENDING',
    color: emailedStatus ? '#20c997' : '#6f42c1',
  };
}
export function getInvoiceTypeText(invoiceType) {
  let text = invoiceType;
  switch (invoiceType) {
    case 'PAY_AS_YOU_GO':
      text = 'Pay As You Go';
      break;
    case 'MONTHLY':
      text = 'Monthly';
      break;

    default:
      break;
  }
  return text;
}

export function getClinicStatusMetaByStatus(status) {
  let color;
  let text = status;
  switch (status) {
    case 'APPROVED':
      color = '#20c997';
      break;
    case 'CREATED':
      color = '#6f42c1';
      break;
    case 'DISAPPROVE':
      color = '#dc3545';
      text = 'DISAPPROVED';
      break;
    case 'DISABLE':
      color = '#D7D7D7';
      text = 'InActive';
      break;
    case 'ENABLE':
      color = '#20c997';
      text = 'Active';
      break;

    default:
      break;
  }
  return {
    text,
    color,
  };
}

export function getClinicPaymentMethodMeta(paymentMethod) {
  let color;
  let text = paymentMethod;
  switch (paymentMethod) {
    case CLINIC_PAYMENT_METHOD_ENUM.PAY_AS_YOU_GO:
      color = '#20c997';
      text = 'PAY AS YOU GO';
      break;
    case CLINIC_PAYMENT_METHOD_ENUM.MONTHLY:
      color = '#6f42c1';
      text = 'MONTHLY';
      break;

    default:
      break;
  }
  return { color, text };
}
export function canUpdateBranchLocationStatus(status) {
  let canUpdate = false;
  switch (status) {
    case CLINIC_STATUS_ENUM.APPROVED:
      canUpdate = true;
      break;

    default:
      break;
  }
  return canUpdate;
}
export function filterClinicActionsByStatus(status) {
  const actionItems = [];
  switch (status) {
    case CLINIC_STATUS_ENUM.CREATED:
      actionItems.push(
        { key: CLINIC_STATUS_ENUM.APPROVED, label: 'Approve', icon: 'fa-check' },
        { key: CLINIC_STATUS_ENUM.DISAPPROVE, label: 'Disapprove', icon: 'fa-times' }
      );
      break;
    case CLINIC_STATUS_ENUM.DISABLE:
      actionItems.push({ key: CLINIC_STATUS_ENUM.ENABLE, label: 'Enable', icon: 'fa-toggle-on' });
      break;
    case CLINIC_STATUS_ENUM.APPROVED:
      actionItems.push({ key: CLINIC_STATUS_ENUM.DISABLE, label: 'Disable', icon: 'fa-toggle-off' });
      break;
    case CLINIC_STATUS_ENUM.DISAPPROVE:
      actionItems.push({ key: CLINIC_STATUS_ENUM.APPROVED, label: 'Approve', icon: 'fa-check' });
      break;

    default:
      break;
  }
  return actionItems;
}
